import {navigateTo, useNuxtApp} from "#imports";
import isPublicUnauthenticatedRoute from '~/utils/isPublicUnauthenticatedRoute';

export default defineNuxtPlugin(nuxtApp => {
    /*
    This middleware runs on every page but login and email login.
    It checks to see if there is valid user object in the Vuex store.
    If user object is empty it will make a fresh call to get the user info.
    If it can't get a valid user it redirects to login
     */
    const checkPermissons = (store, to) => {
        try {
            store.commit('webGeneral/SET_SIDEBAR_MOBILE_TOGGLE', false);
        } catch (e) {
            console.error('[role-redirect] error resetting sidebar toggle', e);
        }

        const user = store.state.auth.user;
        if (user && user.roles?.length && to.name) {
            const [base] = String(to.name).split('-');
            const primaryRole = user.roles[0].value;

            if (to.name.startsWith('theme-admin') && primaryRole === 'participant') {
                return navigateTo('/redirector');
            }
            if (to.name.startsWith('theme-participant') && (primaryRole === 'super-admin' || primaryRole === 'admin')) {
                return navigateTo('/redirector');
            }
            if (to.name.startsWith('theme-login')) {
                return navigateTo('/redirector');
            }
        }
    };

    addRouteMiddleware(async (to) => {
        const routeName = String(to.name || '');
        const isLoginRoute = routeName === 'login' || routeName === 'theme-login';
        const excludedRoutes = [
            'login',
            'theme-login',
            'testcafe-login',
            'theme-testcafe-login',
            'theme-email-login',
            'theme-mfa',
            'redirector'
        ];
        const hasUserToken = Boolean(localStorage.getItem('userToken'));
        const isExcludedRoute = excludedRoutes.includes(routeName);
        const api = nuxtApp.$api;
        const store = nuxtApp.$vuex;
        const authStore = store.state.auth;

        if (hasUserToken && isLoginRoute && !authStore.loggedIn) {
            try {
                const userRequest = await api.getUser();
                store.commit('auth/SET_USER', userRequest.data.data);
                return navigateTo('/redirector');
            } catch (e) {
                store.commit('auth/SET_LOGGED_OUT');
                localStorage.removeItem('userToken');
                return;
            }
        }

        if (!hasUserToken && isExcludedRoute) {
            return;
        }

        if (!isExcludedRoute && !isPublicUnauthenticatedRoute(to.path)) {
            if(!authStore.loggedIn){
                if (!hasUserToken) {
                    store.commit('auth/SET_LOGGED_OUT');
                    if (!routeName.startsWith('theme-login')) {
                        return navigateTo('/redirector');
                    }
                    return;
                }
                try {
                    const userRequest = await api.getUser();
                    store.commit('auth/SET_USER', userRequest.data.data);
                    const redirectResult = checkPermissons(store, to);
                    if (redirectResult) {
                        return redirectResult;
                    }
                    return;

                }catch (e) {
                    if (!routeName.startsWith('theme-login')) {
                        store.commit('auth/SET_LOGGED_OUT');
                        localStorage.removeItem('userToken');
                        return navigateTo('/redirector');
                    }
                    // return navigateTo(`/app/login`);
                }
            }
        }
    });
});
